
























































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import Verifier from '@/components/scanner/Verifier.vue';
import axios from 'axios';
import baseAPI from '@/api/horizon-iium-luxtag/index';

@Component({
    components: {
        Verifier,
    },
})
export default class LandingPageLeftSide extends Vue {
    public certificateNumber: string = '';
    public isPresent: boolean = true;
    public payloadLength: number = 0;
    public verifyURL = process.env.VUE_APP_BASE_API;
    public payloadData = [{ serialNumber: '', studentName: '', program: '', year: '', status: '', action: '', address: '' }];

    public tableHeaders = [
        {
            text: 'Serial Number',
            align: 'left',
            sortable: false,
            value: 'name',
        },
        {
            text: 'Student Name',
            value: 'student_name',
            align: 'left',
            sortable: false,
        },
        {
            text: 'Program',
            value: 'program',
            align: 'left',
            sortable: false,
        },
        {
            text: 'Year',
            value: 'year',
            align: 'left',
            sortable: false,
        },
        {
            text: 'Status',
            value: 'status',
            align: 'left',
            sortable: false,
        },

        {
            text: 'Action',
            value: 'action',
            align: 'left',
            sortable: false,
        },
        // ,
        // {
        //     text: 'Address', value: 'address', align: 'left',
        //     sortable: false,
        // },
    ];

    public verify: boolean = false;
    public isSearch: boolean = false;
    public checkCertificate() {
        this.getCertificate();
    }
    get signers(): string[] {
        return this.$store.getters.getPublicKeys;
    }

    get locale() {
        return this.$store.getters.locale;
    }

    public getCertificate() {
        const URL =
            process.env.VUE_APP_BASE_API +
            `/payload/search?Serial Number=${this.certificateNumber}`;
        axios({
            url: URL,
            method: 'GET',
        }).then((response) => {
            if (response) {
                const payload = response.data;
                this.payloadLength = payload.length;
                const parsedPayload = [{}];
                if (this.payloadLength === 1) {
                    this.isPresent = true;
                    this.onDecode(payload[0].address);
                } else if (this.payloadLength > 1) {
                    this.isPresent = true;
                    this.isSearch = true;
                    for (let i = 0; i < this.payloadLength; i++) {
                        parsedPayload[i] = JSON.parse(payload[i].payload);
                        if (payload[i].revoked) {
                            // @ts-ignore
                            parsedPayload[i].status = 'Revoked';
                        } else {
                            // @ts-ignore
                            parsedPayload[i].status = 'Activated';
                        }
                        // @ts-ignore
                        parsedPayload[i].address = payload[i].address;
                    }
                    for (let i = 0; i < parsedPayload.length; i++) {
                        /* tslint:disable:no-string-literal */
                        // @ts-ignore
                        this.payloadData.push({serialNumber: parsedPayload[i]['Serial Number'], studentName: parsedPayload[i]['Student Name'], program: parsedPayload[i]['Program Name'][0], year: parsedPayload[i].Year, status: parsedPayload[i]['status'], action: 'Verify', address: parsedPayload[i].address,
                        });
                    }
                    this.payloadData.splice(0, 1);
                } else if (this.payloadLength < 1) {
                    this.isPresent = false;
                    this.isSearch = false;
                }
            }
        });
    }
public goBack() {
    this.isSearch = false;
    this.certificateNumber = null;
    this.payloadData = [{ serialNumber: '', studentName: '', program: '', year: '', action: '', status: '', address: '' }];
}
    public async onDecode(decode: string) {
        this.$store.commit('MUTATE_LOADER', true);

        try {
            const res = await baseAPI
                .verify()
                .verifyCertificate(encodeURIComponent(decode), null);

            if (res.verifiedByAuthority) {
                // save payload and move to certificate page
                this.$store.commit('MUTATE_PAYLOAD', res.data);
                this.$router.push('/' + res.data.address);
            } else {
                this.isSearch = false;

            }
        } catch (err) {
            this.isSearch = false;
        } finally {
            this.$store.commit('MUTATE_LOADER', false);
        }
    }
}
